import CircularProgress from '@mui/material/CircularProgress';
import './WhiteLoading.css';

const WhiteLoading = () => {
    return <div className='loading' ><CircularProgress disableShrink /></div>;
}

export default WhiteLoading